<mat-progress-bar
  class="progress-bar"
  mode="determinate"
  value="{{ progressScore }}"
></mat-progress-bar>
